import React from 'react'
import PropTypes from 'prop-types'
import _cx from 'classnames/bind'
import { Text, Modal, PopupTooltip } from '@adc/ui-adc'
import * as graph from '@adc/sdk'
import { ZERO_DOLLARS } from 'common/components/bidBanner/constants'
import ModalAddress from 'common/components/bidBanner/modalAddress'
import { formatMoneyWithNumeral } from 'common/utils/formatters'
import { NO_BIDDING_HISTORY } from 'common/statics'
import cls from './styles.scss'
const cx = _cx.bind(cls)

// TODO: change this whole file to typescript and update bid history unit tests too

const bidInDollars = bid => formatMoneyWithNumeral(bid.bid_amount, ZERO_DOLLARS)

const COUNTER_BID_TOOLTIP_LABEL = 'Seller Counterbid'
const COUNTER_BID_TOOLTIP_CONTENT_1 =
  'Counterbids are common at online and in-person auctions.'
const COUNTER_BID_TOOLTIP_CONTENT_2 =
  'Auction.com may bid on behalf of the Seller to help move the price closer to, but not higher than, Reserve.'
const CounterBidTooltip = () => {
  return (
    <PopupTooltip
      position='top center'
      wide='very'
      trigger={
        <Text
          as='span'
          className={cx('tooltip-label')}
          color='info'
          data-elm-id='counter_bid_tooltip_label'
          size='small'
        >
          <span className='u-mr-1'>{COUNTER_BID_TOOLTIP_LABEL}</span>
        </Text>
      }
      content={
        /* When changing the content, make sure to adjust the modal min-height. */
        <Text
          size='tiny'
          color='white'
          data-elm-id='counter_bid_tooltip_content'
        >
          <p>{COUNTER_BID_TOOLTIP_CONTENT_1}</p>
          <p>{COUNTER_BID_TOOLTIP_CONTENT_2}</p>
        </Text>
      }
    />
  )
}

export default class BiddingHistoryModal extends React.Component {
  static propTypes = {
    biddingHistory: PropTypes.array.isRequired,
    listing: PropTypes.object.isRequired,
  }

  /*
old format for biddingHistory is: [
    {
        "current_user_bid": true,
        "bid_amount": 125000,
        "is_seller_counter_bid": false
    }
]

new format is: [
    {
        "bid_amount": 351000,
        "belongs_to_current_user": true,
        "type": "REGULAR",
        "bid_id": "7822554"
    },
    {
        "bid_amount": 350000,
        "belongs_to_current_user": false,
        "type": "MAX_BID",
        "bid_id": "7822488"
    },
    {
        "bid_amount": 350000,
        "belongs_to_current_user": true,
        "type": "MAX_BID",
        "bid_id": "7822487"
    },
    {
        "bid_amount": 125000,
        "belongs_to_current_user": false,
        "type": "MAX_BID",
        "bid_id": "7822486"
    }
]

  */

  render() {
    const { biddingHistory = [], listing, ...rest } = this.props
    const isMostRecentBidCounter =
      biddingHistory[0]?.type ===
        graph.enums.OnlineAuctionSegmentBidType.SellerCounterBid || false

    const hasCounterBid =
      isMostRecentBidCounter &&
      listing?.listing_configuration?.asset_type ===
        graph.enums.AssetType.BankOwned
    return (
      <Modal
        elmId='bidding_history_modal'
        mobileTitleSkin='light'
        size='tiny'
        title='Bid History'
        style={hasCounterBid ? { minHeight: 350 } : null}
        {...rest}
      >
        <Modal.Content>
          <ModalAddress addressTuple={listing.formatted_address} />

          {!biddingHistory.length && (
            <Text color='gray'>{NO_BIDDING_HISTORY}</Text>
          )}

          <div className={cx('body-1')}>
            {biddingHistory.map((bid, i) => {
              const number = biddingHistory.length - i
              return (
                <div
                  key={i}
                  className={cx('bid', 'u-pb-1', 'u-pt-1')}
                  data-elm-id={`bid_history_bid_${number}`}
                >
                  <Text color='gray' className={cx('u-ml-2', 'u-mr-4')}>
                    {number}.
                  </Text>
                  <div>
                    <Text
                      as='span'
                      className='u-mr-1'
                      color='gray'
                      data-elm-id='bid_amount'
                    >
                      {bidInDollars(bid)}
                    </Text>
                    {i === 0 && hasCounterBid ? (
                      <CounterBidTooltip />
                    ) : (
                      bid.belongs_to_current_user && (
                        <Text
                          as='span'
                          className={cx('current-user-bid')}
                          color='gray'
                          data-elm-id='user_bid'
                          weight='heavy'
                        >
                          (you)
                        </Text>
                      )
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </Modal.Content>
      </Modal>
    )
  }
}
